import Vue from 'vue';
import Vuex from 'vuex';
import auth from '@/store/modules/auth';
import rate from '@/store/modules/rate';
import comment from '@/store/modules/comment';

Vue.use(Vuex);

const lat = localStorage.getItem('lat');
const lng = localStorage.getItem('lng');
const mapZoom = localStorage.getItem('zoom');
const currentLanguage = localStorage.getItem('lang');

const store = new Vuex.Store({
    state: {
        apiKey: 'AIzaSyBRbSm7ZE5ofSJxHan56oyF9tr9SxXcHw4',
        sessionToken: null,
        currentLanguage: currentLanguage || null,
        voted: false,
        messageModel: null,
        progressBarTag: null,
    },

    getters: {
        getFormatedLang(state) {
            return state.currentLanguage
        }
    },

    mutations: {
        setVotedState(state, value) {
            state.voted = value
        },

        setLanguage(state, lang) {
            state.currentLanguage = lang
            localStorage.setItem('lang', lang)
        },

        setSessionToken(state, token) {
            state.sessionToken = token;
        },

        setMessageModel(state, item) {
            state.messageModel = item
        },

        setProgressBarTag(state, tag) {
            state.progressBarTag = tag
        }
    },

    actions: {},

    modules: {
        comment,
        auth,
        rate
    },
});

export default store;
